import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { WOS_BASIC_Schema } from './M_WOS_BASIC_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasicR1,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};
